import AdminConfigTractors from "./AdminConfigTractors";
export default AdminConfigTractors;
